// ─── src/chat/previewMode.js ──────────────────────────────────────────────────
// Preview/test override for Private Aura (the wedding-first experience), so it can
// be seen WITHOUT a registered couple.
//
//   <site>/?aura=private   → turn Private on  (persists in this browser)
//   <site>/?aura=public    → turn Private off
//
// UI-ONLY: it flips the layout gate, nothing else. RLS still applies, and the
// wedding shown is the viewer's own (anonymous) wedding, no other data is exposed.
// Remove / lock this before public launch. See project_two_aura_products.
export function isPreviewPrivate() {
  if (typeof window === "undefined") return false;
  try {
    const p = new URLSearchParams(window.location.search).get("aura");
    if (p === "private") localStorage.setItem("lwd_preview_private", "1");
    if (p === "public")  localStorage.removeItem("lwd_preview_private");
    return localStorage.getItem("lwd_preview_private") === "1";
  } catch { return false; }
}

// Consume ?aura=private the moment this module loads (imported at app entry), so
// the flag persists even before the Aura workspace mounts / if routing strips the
// query string.
try { isPreviewPrivate(); } catch { /* noop */ }
